<template>
  <div class="woot-table sla-reports-table">
    <ve-table
      :fixed-header="true"
      scroll-width="60rem"
      :columns="columns"
      :table-data="items"
      :border-around="false"
    />
  </div>
</template>

<script>
import { VeTable } from 'vue-easytable';

export default {
  components: {
    VeTable,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    searchText: {
      type: String,
      default: '',
    },
  },
  computed: {
    columns() {
      return [
        {
          field: 'sla_name',
          key: 'sla_name',
          title: 'SLA Name',
          align: 'start',
          renderBodyCell: ({ row }) => <div>{row.applied_sla.sla_name}</div>,
        },
        {
          field: 'channel',
          key: 'channel',
          title: 'Channel',
          align: 'start',
          renderBodyCell: ({ row }) => <div>{row.channel.name}</div>,
        },
        {
          field: 'agent',
          key: 'agent',
          title: 'Agent',
          align: 'start',
          renderBodyCell: ({ row }) => (
            <div>{row.conversation?.assignee?.name || '---'}</div>
          ),
        },
        {
          field: 'contact',
          key: 'contact',
          title: 'Contact',
          align: 'start',
          renderBodyCell: ({ row }) => (
            <div>{this.capitalizeWords(row.conversation.contact.name)}</div>
          ),
        },
        {
          field: 'actions',
          key: 'actions',
          title: 'Actions',
          align: 'right',
          renderBodyCell: ({ row }) => (
            <div>
              <woot-button
                variant="link"
                onClick={() => this.$emit('goToConversation', row)}
              >
                Go to conversation
              </woot-button>
              <woot-button
                variant="link"
                nativeOnMouseover={event =>
                  this.handleShowDetails(row, true, event)
                }
                nativeOnMouseleave={event =>
                  this.handleShowDetails(row, false, event)
                }
              >
                Details
              </woot-button>
            </div>
          ),
        },
      ];
    },
  },
  methods: {
    handleShowDetails(row, show, event) {
      this.$emit('showDetails', { row, show, event });
    },
    capitalizeWords(str) {
      return str
        .replace(/-/g, ' ')
        .toLowerCase()
        .replace(/\b\w/g, char => char.toUpperCase());
    },
  },
};
</script>
<style lang="scss">
@import 'dashboard/assets/scss/widgets/_woot-tables.scss';
.sla-reports-table .ve-table-container {
  max-height: calc(100vh - 50rem);
}

@media screen and (min-width: 1301px) and (max-width: 1800px) {
  .sla-reports-table .ve-table-container {
    max-height: calc(100vh - 37.6rem);
  }
}

@media screen and (min-width: 1801px) {
  .sla-reports-table .ve-table-container {
    max-height: calc(100vh - 32.6rem);
  }
}
</style>
